import { UploadType } from "../Components/DropZone";

export function uploadAction(state: Record<string, any>, payload: UploadType) {
  switch (payload.type) {
    case "plumbing_plan":
      if (state?.uploads?.plumbing_plan.length > 4) {
        return state;
      }
      return {
        ...state,
        uploads: {
          ...state?.uploads,
          plumbing_plan: state?.uploads?.plumbing_plan
            ? [
                ...state?.uploads.plumbing_plan.filter(
                  (file) => file.name !== payload.name
                ),
                payload,
              ]
            : [payload],
        },
      };
    case "menu":
      if (state?.uploads?.menu.length > 4) {
        return state;
      }
      return {
        ...state,
        uploads: {
          ...state?.uploads,
          menu: state?.uploads?.menu
            ? [
                ...state?.uploads.menu.filter(
                  (file) => file.name !== payload.name
                ),
                payload,
              ]
            : [payload],
        },
      };
    case "delete":
      return {
        ...state,
        uploads: {
          ...state?.uploads,
          [payload.uploadType as string]: state?.uploads[
            payload.uploadType as string
          ]?.filter((upload: UploadType) => upload.id !== payload.id),
        },
      };
    case "delete_all":
      return {
        ...state,
        uploads: {
          menu: [],
          plumbing_plan: [],
        },
      };

    default:
      return state;
  }
}

export function updateAction(state: Record<string, any>, payload: any) {
  return {
    ...state,
    data: {
      ...state?.data,
      ...payload,
    },
  };
}

export function resetAction() {
  return {};
}
